import { Roundel as ProductRoundel } from '../types/generated';
export interface RoundelsProps {
  roundel: ProductRoundel | null;
}

export default function Roundels({ roundel }: RoundelsProps) {
  if (
    !roundel?.name ||
    roundel?.name === '' ||
    (!roundel?.isVendorRoundel &&
      (!roundel?.fileName || roundel?.fileName === ''))
  ) {
    return null;
  }

  let cssModifier = '';

  switch (roundel.name.toLowerCase()) {
    case 'offer':
      cssModifier = 'offer';
      break;
    case 'new':
      cssModifier = 'new';
      break;
    case 'bestseller':
      cssModifier = 'best-seller';
      break;
    case 'exclusive':
      cssModifier = 'exclusive'; // used for other exclusive
      break;
    case 'vendor':
      switch (roundel.text?.toLocaleLowerCase()) {
        case 'findel':
          cssModifier = 'findel';
          break;
        case 'clickety books':
          cssModifier = 'clickety-books';
          break;
        case 'cosy direct':
          cssModifier = 'cosy';
          break;
        case 'dryad big book':
          cssModifier = 'dryad-big-book';
          break;
        case 'dryad education':
          cssModifier = 'dryad-education';
          break;
        case 'gam':
          cssModifier = 'gam';
          break;
        case 'heart':
          cssModifier = 'heart';
          break;
        case 'kidzinc':
          cssModifier = 'kidzinc';
          break;
        case 'normans musical instruments':
          cssModifier = 'normans-music';
          break;
        case 'pottery crafts':
          cssModifier = 'pottery-crafts';
          break;
        case 'specialist crafts':
          cssModifier = 'specialist-crafts';
          break;
        case 'surestitch':
          cssModifier = 'surestitch';
          break;
        case 'wildgoose':
          cssModifier = 'wildgoose';
          break;
        default:
          break;
      }
      break;
    default:
      cssModifier = 'default';
      break;
  }

  return (
    <Roundel
      name={roundel.name}
      cssModifier={cssModifier}
      fileName={roundel.fileName}
    />
  );
}

interface RoundelProps {
  name: string | null;
  cssModifier: string;
  fileName: string | null;
}

function Roundel({ name, cssModifier, fileName }: RoundelProps) {
  return fileName && fileName != '' ? (
    <div
      className={`roundel roundel--${cssModifier}`}
      style={{ backgroundImage: `url(${fileName})` }}
    >
      {name}
    </div>
  ) : (
    <div className={`roundel roundel--${cssModifier}`}>{name}</div>
  );
}
